"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getFactors = getFactors;
exports.deleteFactor = deleteFactor;
exports.deleteFactors = deleteFactors;
exports.initFactorSetup = initFactorSetup;
exports.initEmergencyCodesSetup = initEmergencyCodesSetup;
exports.getAllFactors = getAllFactors;
exports.enableMultifactorAuthCode = enableMultifactorAuthCode;
exports.registerMultifactorAuthCode = registerMultifactorAuthCode;
exports.getMfaStaffPreference = getMfaStaffPreference;
exports.staffRequired = staffRequired;
exports.getMfaClientPreference = getMfaClientPreference;
exports.clientsRequired = clientsRequired;
exports.userRequired = userRequired;
exports.setStaffRequired = setStaffRequired;
exports.setClientsRequired = setClientsRequired;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

require("regenerator-runtime/runtime");

var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _access = require("../access");

var _environment = require("../environment");

var _permission = require("../permission");

var _preference = require("../preference");

var _session = require("../session");

var _utils = require("../utils");

var _internals = require("../utils/internals");

var _constants = require("./constants");

function getJWt(jwtToken) {
  var jwt = jwtToken !== null && jwtToken !== void 0 ? jwtToken : _session.store.jwt();

  if (typeof jwt === 'undefined' || (0, _utils.isNullOrEmpty)(jwt) || jwt === null) {
    throw new Error('MFA needs a JWT token from the key tr-auth-token in sessionStorage');
  }

  return jwt;
}

var cachedProductOptions;

function getMfaProductOptions() {
  return _getMfaProductOptions.apply(this, arguments);
}

function _getMfaProductOptions() {
  _getMfaProductOptions = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (cachedProductOptions === undefined) {
              cachedProductOptions = (0, _environment.getPrimaryProduct)().then(function (productName) {
                return _constants.products[productName] ? _constants.products[productName] : _constants.products.onvio;
              });
            }

            return _context.abrupt("return", cachedProductOptions);

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getMfaProductOptions.apply(this, arguments);
}

function getMfaApi() {
  return _getMfaApi.apply(this, arguments);
}

function _getMfaApi() {
  _getMfaApi = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    return _regenerator.default.wrap(function _callee2$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", (0, _environment.getRoute)('MultifactorAuthenticationServices').then(function (api) {
              var _context2, _context3;

              var routeUri = (0, _utils.parseUri)(api);
              var hostUri = (0, _utils.parseUri)(window.location.href);
              return (0, _concat.default)(_context2 = (0, _concat.default)(_context3 = "".concat(hostUri.protocol, "//")).call(_context3, routeUri.host)).call(_context2, routeUri.pathname);
            }));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee2);
  }));
  return _getMfaApi.apply(this, arguments);
}

function getAuthApi() {
  return _getAuthApi.apply(this, arguments);
}

function _getAuthApi() {
  _getAuthApi = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
    return _regenerator.default.wrap(function _callee3$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", (0, _environment.getRoute)('AuthenticationAggregatorServices').then(function (api) {
              var _context5;

              var routeUri = (0, _utils.parseUri)(api);
              return (0, _concat.default)(_context5 = "".concat(routeUri.protocol, "//")).call(_context5, routeUri.host);
            }));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee3);
  }));
  return _getAuthApi.apply(this, arguments);
}

function getBaseFactorsConfig(jwtToken) {
  return {
    body: null,
    cache: undefined,
    headers: (0, _utils.jsonHeaders)({
      Authorization: 'Bearer ' + getJWt(jwtToken)
    }),
    method: 'GET'
  };
}

function sortAuthCodeList(authCodeList) {
  (0, _sort.default)(authCodeList).call(authCodeList, function (a, b) {
    a = new Date(a.registered);
    b = new Date(b.registered);
    return b - a;
  });
  return authCodeList;
}

function getFactors() {
  return _getFactors.apply(this, arguments);
}

function _getFactors() {
  _getFactors = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
    var config;
    return _regenerator.default.wrap(function _callee6$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            config = getBaseFactorsConfig();
            return _context9.abrupt("return", (0, _access.has)('Platform_Enable2FA').then(function (hasAccess) {
              if (!hasAccess) {
                return [];
              }

              return getMfaApi().then( /*#__PURE__*/function () {
                var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(api) {
                  return _regenerator.default.wrap(function _callee4$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          return _context7.abrupt("return", fetch("".concat(api, "/v1/factors"), config));

                        case 1:
                        case "end":
                          return _context7.stop();
                      }
                    }
                  }, _callee4);
                }));

                return function (_x27) {
                  return _ref.apply(this, arguments);
                };
              }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
                var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(response) {
                  return _regenerator.default.wrap(function _callee5$(_context8) {
                    while (1) {
                      switch (_context8.prev = _context8.next) {
                        case 0:
                          return _context8.abrupt("return", response.json());

                        case 1:
                        case "end":
                          return _context8.stop();
                      }
                    }
                  }, _callee5);
                }));

                return function (_x28) {
                  return _ref2.apply(this, arguments);
                };
              }()).then(function (body) {
                var factors = [];

                if ((0, _isArray.default)(body) && body.length > 0) {
                  factors = (0, _filter.default)(body).call(body, function (factor) {
                    return typeof factor.type === 'string' && factor.type.toUpperCase() !== 'B';
                  });
                }

                return factors;
              });
            }));

          case 2:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee6);
  }));
  return _getFactors.apply(this, arguments);
}

function deleteFactor(_x, _x2) {
  return _deleteFactor.apply(this, arguments);
}

function _deleteFactor() {
  _deleteFactor = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(factor, jwtToken) {
    var config;
    return _regenerator.default.wrap(function _callee8$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            config = getBaseFactorsConfig(jwtToken);
            config.method = 'DELETE';
            return _context12.abrupt("return", getMfaApi().then(function (api) {
              return "".concat(api, "/v1/factors");
            }).then( /*#__PURE__*/function () {
              var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(url) {
                var _context10;

                return _regenerator.default.wrap(function _callee7$(_context11) {
                  while (1) {
                    switch (_context11.prev = _context11.next) {
                      case 0:
                        return _context11.abrupt("return", fetch((0, _concat.default)(_context10 = "".concat(url, "/")).call(_context10, factor.id), config));

                      case 1:
                      case "end":
                        return _context11.stop();
                    }
                  }
                }, _callee7);
              }));

              return function (_x29) {
                return _ref3.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower));

          case 3:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee8);
  }));
  return _deleteFactor.apply(this, arguments);
}

function deleteFactors(_x3, _x4) {
  return _deleteFactors.apply(this, arguments);
}

function _deleteFactors() {
  _deleteFactors = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(factors, jwtToken) {
    return _regenerator.default.wrap(function _callee10$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            return _context14.abrupt("return", _promise.default.all((0, _map.default)(factors).call(factors, /*#__PURE__*/function () {
              var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(factor) {
                return _regenerator.default.wrap(function _callee9$(_context13) {
                  while (1) {
                    switch (_context13.prev = _context13.next) {
                      case 0:
                        return _context13.abrupt("return", deleteFactor(factor, jwtToken));

                      case 1:
                      case "end":
                        return _context13.stop();
                    }
                  }
                }, _callee9);
              }));

              return function (_x30) {
                return _ref4.apply(this, arguments);
              };
            }())));

          case 1:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee10);
  }));
  return _deleteFactors.apply(this, arguments);
}

function promisedTRAuth(_x5) {
  return _promisedTRAuth.apply(this, arguments);
}

function _promisedTRAuth() {
  _promisedTRAuth = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(options) {
    return _regenerator.default.wrap(function _callee11$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            return _context15.abrupt("return", new _promise.default(function (resolve) {
              var success = function success() {
                window.removeEventListener('tr-mfs-success', success);
                window.removeEventListener('tr-mfs-exit', success);
                window.removeEventListener('tr-dialog-user-closed', close);
                resolve(true);
              };

              var close = function close() {
                window.removeEventListener('tr-mfs-success', success);
                window.removeEventListener('tr-mfs-exit', success);
                window.removeEventListener('tr-dialog-user-closed', close);
                resolve(false);
              };

              window.trAuth.modules.mfs.init(options);
              window.addEventListener('tr-mfs-success', success);
              window.addEventListener('tr-mfs-exit', success);
              window.addEventListener('tr-dialog-user-closed', close);
            }));

          case 1:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee11);
  }));
  return _promisedTRAuth.apply(this, arguments);
}

function initFactorSetup(_x6, _x7, _x8) {
  return _initFactorSetup.apply(this, arguments);
}

function _initFactorSetup() {
  _initFactorSetup = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14(email, lang, startingForm) {
    return _regenerator.default.wrap(function _callee14$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            if (window.trAuth) {
              _context18.next = 2;
              break;
            }

            throw new Error('tr-auth is not avaiable. Please include the script into the site.');

          case 2:
            return _context18.abrupt("return", getAuthApi().then( /*#__PURE__*/function () {
              var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12(api) {
                return _regenerator.default.wrap(function _callee12$(_context16) {
                  while (1) {
                    switch (_context16.prev = _context16.next) {
                      case 0:
                        return _context16.abrupt("return", _promise.default.all([api, getMfaProductOptions()]));

                      case 1:
                      case "end":
                        return _context16.stop();
                    }
                  }
                }, _callee12);
              }));

              return function (_x31) {
                return _ref5.apply(this, arguments);
              };
            }()).then( /*#__PURE__*/function () {
              var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13(_ref6) {
                var _ref8, api, options;

                return _regenerator.default.wrap(function _callee13$(_context17) {
                  while (1) {
                    switch (_context17.prev = _context17.next) {
                      case 0:
                        _ref8 = (0, _slicedToArray2.default)(_ref6, 2), api = _ref8[0], options = _ref8[1];
                        return _context17.abrupt("return", promisedTRAuth({
                          headers: {
                            authorization: 'Bearer ' + getJWt()
                          },
                          locale: lang,
                          sp: options.sp,
                          templateData: {
                            authSvcHost: api,
                            onvioHelpDomain: api,
                            uid: email
                          },
                          type: options.type,
                          startingForm: startingForm
                        }));

                      case 2:
                      case "end":
                        return _context17.stop();
                    }
                  }
                }, _callee13);
              }));

              return function (_x32) {
                return _ref7.apply(this, arguments);
              };
            }()));

          case 3:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee14);
  }));
  return _initFactorSetup.apply(this, arguments);
}

function initEmergencyCodesSetup(_x9, _x10) {
  return _initEmergencyCodesSetup.apply(this, arguments);
}

function _initEmergencyCodesSetup() {
  _initEmergencyCodesSetup = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15(email, lang) {
    return _regenerator.default.wrap(function _callee15$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            return _context19.abrupt("return", initFactorSetup(email, lang, 'trta1-mfs-emergencycodes'));

          case 1:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee15);
  }));
  return _initEmergencyCodesSetup.apply(this, arguments);
}

function setMfaStaffPreference(_x11, _x12) {
  return _setMfaStaffPreference.apply(this, arguments);
}

function _setMfaStaffPreference() {
  _setMfaStaffPreference = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16(required, companyId) {
    var preference;
    return _regenerator.default.wrap(function _callee16$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            preference = {
              application: 'onvio',
              category: 'mfa-staff',
              value: {
                required: required
              }
            };
            return _context20.abrupt("return", (0, _preference.addPreference)(preference, companyId));

          case 2:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee16);
  }));
  return _setMfaStaffPreference.apply(this, arguments);
}

function setMfaClientPreference(_x13, _x14) {
  return _setMfaClientPreference.apply(this, arguments);
}

function _setMfaClientPreference() {
  _setMfaClientPreference = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17(required, companyId) {
    var preference;
    return _regenerator.default.wrap(function _callee17$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            preference = {
              application: 'onvio',
              category: 'mfa-client',
              value: {
                required: required
              }
            };
            return _context21.abrupt("return", (0, _preference.addPreference)(preference, companyId));

          case 2:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee17);
  }));
  return _setMfaClientPreference.apply(this, arguments);
}

function getAllFactors(_x15) {
  return _getAllFactors.apply(this, arguments);
}

function _getAllFactors() {
  _getAllFactors = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee20(jwtToken) {
    var config;
    return _regenerator.default.wrap(function _callee20$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            config = getBaseFactorsConfig(jwtToken);
            return _context24.abrupt("return", getMfaApi().then( /*#__PURE__*/function () {
              var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee18(api) {
                return _regenerator.default.wrap(function _callee18$(_context22) {
                  while (1) {
                    switch (_context22.prev = _context22.next) {
                      case 0:
                        return _context22.abrupt("return", fetch("".concat(api, "/v1/factors"), config));

                      case 1:
                      case "end":
                        return _context22.stop();
                    }
                  }
                }, _callee18);
              }));

              return function (_x33) {
                return _ref9.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee19(response) {
                return _regenerator.default.wrap(function _callee19$(_context23) {
                  while (1) {
                    switch (_context23.prev = _context23.next) {
                      case 0:
                        return _context23.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context23.stop();
                    }
                  }
                }, _callee19);
              }));

              return function (_x34) {
                return _ref10.apply(this, arguments);
              };
            }()).then(function (body) {
              var factors = [];

              if ((0, _isArray.default)(body) && body.length > 0) {
                factors = body;
              }

              factors = sortAuthCodeList(factors);
              return factors;
            }).catch(function () {
              return [];
            }));

          case 2:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee20);
  }));
  return _getAllFactors.apply(this, arguments);
}

function enableMultifactorAuthCode(_x16) {
  return _enableMultifactorAuthCode.apply(this, arguments);
}

function _enableMultifactorAuthCode() {
  _enableMultifactorAuthCode = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee23(jwtToken) {
    var config;
    return _regenerator.default.wrap(function _callee23$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            config = getBaseFactorsConfig(jwtToken);
            config.method = 'POST';
            config.cache = 'no-cache';
            config.body = (0, _stringify.default)({
              address: '24-hour code',
              type: 'B'
            });
            return _context27.abrupt("return", getMfaApi().then( /*#__PURE__*/function () {
              var _ref11 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee21(api) {
                return _regenerator.default.wrap(function _callee21$(_context25) {
                  while (1) {
                    switch (_context25.prev = _context25.next) {
                      case 0:
                        return _context25.abrupt("return", fetch("".concat(api, "/v1/factors"), config));

                      case 1:
                      case "end":
                        return _context25.stop();
                    }
                  }
                }, _callee21);
              }));

              return function (_x35) {
                return _ref11.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref12 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee22(response) {
                return _regenerator.default.wrap(function _callee22$(_context26) {
                  while (1) {
                    switch (_context26.prev = _context26.next) {
                      case 0:
                        return _context26.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context26.stop();
                    }
                  }
                }, _callee22);
              }));

              return function (_x36) {
                return _ref12.apply(this, arguments);
              };
            }()).catch(function (error) {
              return error;
            }));

          case 5:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee23);
  }));
  return _enableMultifactorAuthCode.apply(this, arguments);
}

function registerMultifactorAuthCode(_x17, _x18) {
  return _registerMultifactorAuthCode.apply(this, arguments);
}

function _registerMultifactorAuthCode() {
  _registerMultifactorAuthCode = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee26(jwtToken, inputData) {
    var config;
    return _regenerator.default.wrap(function _callee26$(_context31) {
      while (1) {
        switch (_context31.prev = _context31.next) {
          case 0:
            config = getBaseFactorsConfig(jwtToken);
            config.method = 'POST';
            config.cache = 'no-cache';
            config.body = (0, _stringify.default)({
              factor: {
                address: 'Support',
                name: '24-hour code'
              },
              mfarId: inputData.mfarId
            });
            return _context31.abrupt("return", getMfaApi().then( /*#__PURE__*/function () {
              var _ref13 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee24(api) {
                var _context28;

                return _regenerator.default.wrap(function _callee24$(_context29) {
                  while (1) {
                    switch (_context29.prev = _context29.next) {
                      case 0:
                        return _context29.abrupt("return", fetch((0, _concat.default)(_context28 = "".concat(api, "/v1/factors/")).call(_context28, inputData.factorId, "/register"), config));

                      case 1:
                      case "end":
                        return _context29.stop();
                    }
                  }
                }, _callee24);
              }));

              return function (_x37) {
                return _ref13.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref14 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee25(response) {
                return _regenerator.default.wrap(function _callee25$(_context30) {
                  while (1) {
                    switch (_context30.prev = _context30.next) {
                      case 0:
                        return _context30.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context30.stop();
                    }
                  }
                }, _callee25);
              }));

              return function (_x38) {
                return _ref14.apply(this, arguments);
              };
            }()).catch(function (error) {
              return error;
            }));

          case 5:
          case "end":
            return _context31.stop();
        }
      }
    }, _callee26);
  }));
  return _registerMultifactorAuthCode.apply(this, arguments);
}

function getMfaStaffPreference(_x19) {
  return _getMfaStaffPreference.apply(this, arguments);
}

function _getMfaStaffPreference() {
  _getMfaStaffPreference = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee27(companyId) {
    var application, category;
    return _regenerator.default.wrap(function _callee27$(_context32) {
      while (1) {
        switch (_context32.prev = _context32.next) {
          case 0:
            application = 'onvio';
            category = 'mfa-staff';
            return _context32.abrupt("return", (0, _preference.getPreference)(application, category, companyId));

          case 3:
          case "end":
            return _context32.stop();
        }
      }
    }, _callee27);
  }));
  return _getMfaStaffPreference.apply(this, arguments);
}

function staffRequired(_x20) {
  return _staffRequired.apply(this, arguments);
}

function _staffRequired() {
  _staffRequired = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee28(companyId) {
    return _regenerator.default.wrap(function _callee28$(_context33) {
      while (1) {
        switch (_context33.prev = _context33.next) {
          case 0:
            if (companyId) {
              _context33.next = 2;
              break;
            }

            return _context33.abrupt("return", _promise.default.reject(new Error('Missing or empty companyId')));

          case 2:
            return _context33.abrupt("return", getMfaStaffPreference(companyId).then(function (data) {
              if ((0, _isArray.default)(data) && data.length > 0) {
                var _preference$value;

                var preference = data[0];
                return ((_preference$value = preference.value) === null || _preference$value === void 0 ? void 0 : _preference$value.required) || false;
              }

              return false;
            }));

          case 3:
          case "end":
            return _context33.stop();
        }
      }
    }, _callee28);
  }));
  return _staffRequired.apply(this, arguments);
}

function getMfaClientPreference(_x21) {
  return _getMfaClientPreference.apply(this, arguments);
}

function _getMfaClientPreference() {
  _getMfaClientPreference = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee29(companyId) {
    var application, category;
    return _regenerator.default.wrap(function _callee29$(_context34) {
      while (1) {
        switch (_context34.prev = _context34.next) {
          case 0:
            application = 'onvio';
            category = 'mfa-client';
            return _context34.abrupt("return", (0, _preference.getPreference)(application, category, companyId));

          case 3:
          case "end":
            return _context34.stop();
        }
      }
    }, _callee29);
  }));
  return _getMfaClientPreference.apply(this, arguments);
}

function clientsRequired(_x22) {
  return _clientsRequired.apply(this, arguments);
}

function _clientsRequired() {
  _clientsRequired = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee30(companyId) {
    return _regenerator.default.wrap(function _callee30$(_context35) {
      while (1) {
        switch (_context35.prev = _context35.next) {
          case 0:
            if (companyId) {
              _context35.next = 2;
              break;
            }

            return _context35.abrupt("return", _promise.default.reject(new Error('Missing or empty companyId')));

          case 2:
            return _context35.abrupt("return", getMfaClientPreference(companyId).then(function (data) {
              if ((0, _isArray.default)(data) && data.length > 0) {
                var _preference$value2;

                var preference = data[0];
                return ((_preference$value2 = preference.value) === null || _preference$value2 === void 0 ? void 0 : _preference$value2.required) || false;
              }

              return false;
            }));

          case 3:
          case "end":
            return _context35.stop();
        }
      }
    }, _callee30);
  }));
  return _clientsRequired.apply(this, arguments);
}

function userRequired() {
  return _userRequired.apply(this, arguments);
}

function _userRequired() {
  _userRequired = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee33() {
    return _regenerator.default.wrap(function _callee33$(_context38) {
      while (1) {
        switch (_context38.prev = _context38.next) {
          case 0:
            return _context38.abrupt("return", _promise.default.all([(0, _permission.has)('Platform.DefaultClient'), (0, _permission.has)('Platform.DefaultStaff')]).then( /*#__PURE__*/function () {
              var _ref16 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee32(_ref15) {
                var _ref17, isClient, isStaff;

                return _regenerator.default.wrap(function _callee32$(_context37) {
                  while (1) {
                    switch (_context37.prev = _context37.next) {
                      case 0:
                        _ref17 = (0, _slicedToArray2.default)(_ref15, 2), isClient = _ref17[0], isStaff = _ref17[1];
                        return _context37.abrupt("return", (0, _session.getBindings)().then( /*#__PURE__*/function () {
                          var _ref18 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee31(bindings) {
                            return _regenerator.default.wrap(function _callee31$(_context36) {
                              while (1) {
                                switch (_context36.prev = _context36.next) {
                                  case 0:
                                    if (!isStaff) {
                                      _context36.next = 2;
                                      break;
                                    }

                                    return _context36.abrupt("return", staffRequired(bindings.ApplicationConfiguration.CompanyId));

                                  case 2:
                                    if (!isClient) {
                                      _context36.next = 4;
                                      break;
                                    }

                                    return _context36.abrupt("return", clientsRequired(bindings.ApplicationConfiguration.CompanyId));

                                  case 4:
                                    return _context36.abrupt("return", _promise.default.resolve(false));

                                  case 5:
                                  case "end":
                                    return _context36.stop();
                                }
                              }
                            }, _callee31);
                          }));

                          return function (_x40) {
                            return _ref18.apply(this, arguments);
                          };
                        }()));

                      case 2:
                      case "end":
                        return _context37.stop();
                    }
                  }
                }, _callee32);
              }));

              return function (_x39) {
                return _ref16.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context38.stop();
        }
      }
    }, _callee33);
  }));
  return _userRequired.apply(this, arguments);
}

function setStaffRequired(_x23, _x24) {
  return _setStaffRequired.apply(this, arguments);
}

function _setStaffRequired() {
  _setStaffRequired = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee34(companyId, required) {
    return _regenerator.default.wrap(function _callee34$(_context39) {
      while (1) {
        switch (_context39.prev = _context39.next) {
          case 0:
            if (!(typeof companyId === 'undefined' || typeof required === 'undefined')) {
              _context39.next = 2;
              break;
            }

            return _context39.abrupt("return", _promise.default.reject(new Error('Missing or empty companyId or required')));

          case 2:
            return _context39.abrupt("return", setMfaStaffPreference(required, companyId));

          case 3:
          case "end":
            return _context39.stop();
        }
      }
    }, _callee34);
  }));
  return _setStaffRequired.apply(this, arguments);
}

function setClientsRequired(_x25, _x26) {
  return _setClientsRequired.apply(this, arguments);
}

function _setClientsRequired() {
  _setClientsRequired = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee35(companyId, required) {
    return _regenerator.default.wrap(function _callee35$(_context40) {
      while (1) {
        switch (_context40.prev = _context40.next) {
          case 0:
            if (!(typeof companyId === 'undefined' || typeof required === 'undefined')) {
              _context40.next = 2;
              break;
            }

            return _context40.abrupt("return", _promise.default.reject(new Error('Missing or empty companyId or required')));

          case 2:
            return _context40.abrupt("return", setMfaClientPreference(required, companyId));

          case 3:
          case "end":
            return _context40.stop();
        }
      }
    }, _callee35);
  }));
  return _setClientsRequired.apply(this, arguments);
}
